import { useMemo } from 'react';
// @mui
import { Typography, Box, Tooltip } from '@mui/material';
// _mock_
import { connectionStatus } from '../../../_mock';
// hooks
import useLocales from '../../../hooks/useLocales';
import { useSupabaseRealtime } from '../../../contexts/SupabaseRealtimeContext';
// components
import Iconify from '../../../components/Iconify';
import { IconButtonRippleAnimate } from '../../../components/animate';

// ----------------------------------------------------------------------

export default function ConnectionIndicator() {

  const realtime = useSupabaseRealtime();

  const { t } = useLocales()

  // Determine connection status based on Supabase Realtime connection
  // Use connection status from context, with fallback to check channels
  const connectionState = useMemo(() => {
    if (realtime.connection === 'connected' && realtime.channels.length > 0) {
      return 'connected';
    }
    
    // If we have channels but connection is disconnected, we might be reconnecting
    if (realtime.channels.length > 0 && realtime.connection === 'disconnected') {
      return 'reconnecting';
    }
    
    return 'disconnected';
  }, [realtime.connection, realtime.channels]);

  const handleReconnect = () => {
    if (connectionState === 'disconnected') {
      window.location.reload()
    }
  };

  const status = connectionStatus.find((status) => status.label === connectionState) || connectionStatus[0];

  return (
    <Box display='flex' flexDirection='row' alignItems='center' sx={{ pr: { xs: 0, sm: 4 } }}>
      <Tooltip title={t(`buttons.${status.action}`)}>
        <IconButtonRippleAnimate
          onClick={handleReconnect}
          rippleColor={status.ripple}
          sx={[{ pr: 1, color: `${status.color}.main` }, status.label !== 'disconnected' && { pointerEvents: 'none' }]}
        > 
          <Iconify icon={status.icon} />
        </IconButtonRippleAnimate>
      </Tooltip>

      <Typography
        variant='subtitle2'
        sx={{ color: 'text.primary', display: { xs: 'none', sm: 'block' } }}
      >
        {t(`status.label.${status.label}`)}
      </Typography>
    </Box>
  );
}
